/** UAE / GCC location options for registration and browse filters */
export const LOCATION_OPTIONS = [
  { city: "Dubai", country: "United Arab Emirates", lat: 25.2048, lng: 55.2708 },
  { city: "Abu Dhabi", country: "United Arab Emirates", lat: 24.4539, lng: 54.3773 },
  { city: "Sharjah", country: "United Arab Emirates", lat: 25.3463, lng: 55.4209 },
  { city: "Ajman", country: "United Arab Emirates", lat: 25.4052, lng: 55.5136 },
  { city: "Ras Al Khaimah", country: "United Arab Emirates", lat: 25.7895, lng: 55.9432 },
  { city: "Fujairah", country: "United Arab Emirates", lat: 25.1288, lng: 56.3265 },
  { city: "Umm Al Quwain", country: "United Arab Emirates", lat: 25.5647, lng: 55.5552 },
  { city: "Riyadh", country: "Saudi Arabia", lat: 24.7136, lng: 46.6753 },
  { city: "Doha", country: "Qatar", lat: 25.2854, lng: 51.5310 },
  { city: "Manama", country: "Bahrain", lat: 26.2235, lng: 50.5876 },
  { city: "Kuwait City", country: "Kuwait", lat: 29.3759, lng: 47.9774 },
  { city: "Muscat", country: "Oman", lat: 23.5880, lng: 58.3829 },
  { city: "Remote", country: "Remote", lat: null, lng: null },
];

export const AVAILABILITY_OPTIONS = [
  { value: "available", label: "Available now" },
  { value: "part_time", label: "Part-time" },
  { value: "busy", label: "Busy / limited" },
];

export const LANGUAGE_OPTIONS = [
  "English", "Arabic", "Hindi", "Urdu", "French", "Spanish", "Tagalog", "Malayalam",
];

export function findLocation(value) {
  return LOCATION_OPTIONS.find(
    (loc) => `${loc.city}, ${loc.country}` === value || loc.city === value,
  );
}
